import { createSlice } from "@reduxjs/toolkit";

const wfNotificationSlice = createSlice({
  name: "wfNotification",
  initialState: {
    totalUnreadCount: 0,
  },
  reducers: {
    updateTotalUnreadCount(state, payload) {
      state.totalUnreadCount = payload?.payload?.count || 0;
    },
  },
});

export const { updateTotalUnreadCount } = wfNotificationSlice.actions;
export default wfNotificationSlice.reducer;
